export default __webpack_public_path__ + "static/media/private.346b5eb2.svg";